import {
  AboutBox,
  Section,
  SectionBox,
  Heading,
  Image,
  TextBoxTop,
  TextBoxBottom,
  ImageBoxTop,
  ImageBoxBottom
} from './styled.js'

import miki1 from '../mm_63 (1).JPG'
import miki2 from '../mm_79.JPG'

const AboutUs = () => (
  <Section id='onas'>
    <SectionBox>
      <AboutBox>
        <TextBoxTop>
          <div>
            <Heading>O nas</Heading>
            <p>
              Jesteśmy firmą rodzinną, która z roku na rok powiększa się o
              kolejnego maluszka, dlatego dobrze wiemy, jak ważne jest, by mieć
              pewność, że to, czego używamy dla naszych cudownych dzieci, jest
              naprawdę bezpieczne, wygodne i skuteczne.
            </p>
          </div>
        </TextBoxTop>

        <ImageBoxTop>
          <Image src={miki1} alt='zdjęcie chłopca' />
        </ImageBoxTop>

        <ImageBoxBottom>
          <Image src={miki2} alt='dziecko w pieluszce' />
        </ImageBoxBottom>

        <TextBoxBottom>
          <p>
            Pomysł stworzenia własnych pieluszek zrodził się z codziennych
            doświadczeń - prób i błędów i poszukiwania produktu, który nie tylko
            dobrze chłonie, ale również nie podrażnia delikatnej skóry dziecka.
            Chcieliśmy, żeby nasze pieluszki były delikatne jak dotyk mamy, a
            przy tym naprawdę niezawodne - bez przecieków, bez kompromisów.
          </p>
        </TextBoxBottom>
      </AboutBox>
    </SectionBox>
  </Section>
)

export default AboutUs
